import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {
  CustomComponentEditorProps,
  FIELD_ORDER_UI_SCHEMA_KEY,
  SECTION_NAME_UI_SCHEMA_KEY,
  ShapeUISchema,
  SHOW_DIVIDER_LINE_KEY,
} from '../../StepConfigEditorTypes';
import StepConfigEditorRouter from '../StepConfigEditorRouter';
import StepConfigFieldsTemplate from '../StepConfigFieldsTemplate';

const LOOKUP_CONFIG_SECTION_UI_SCHEMA: ShapeUISchema = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['lookupColumn', 'lookupBy'],
  [SECTION_NAME_UI_SCHEMA_KEY]: 'Configure look up',
  [SHOW_DIVIDER_LINE_KEY]: false,
  lookupColumn: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['lookupColumn'],
    lookupColumn: {
      displayName: 'Select look up column',
      infoText: 'This is the column in your input table that contains identifiers for Benchling objects.',
      configShapePath: ['lookupColumn'],
    },
  },
  lookupBy: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['lookupBy'],
    lookupBy: {
      displayName: 'Select identifier format',
      infoText:
        'Choose the type of identifier (Name, Id, or Barcode) that matches the values in your selected lookup column.',
      configShapePath: ['lookupBy'],
      fieldSettings: {
        displayNames: {
          id: 'Id',
          name: 'Name',
          barcode: 'Barcode',
        },
      },
    },
  },
};

export default function LookUpConfigSectionEditor({
  config,
  onChangeConfig,
  disabled,
  configShape,
}: CustomComponentEditorProps): JSX.Element {
  const fieldOrder = LOOKUP_CONFIG_SECTION_UI_SCHEMA[FIELD_ORDER_UI_SCHEMA_KEY];
  const fields = fieldOrder.map((variableName) => {
    const field = LOOKUP_CONFIG_SECTION_UI_SCHEMA[variableName] as ShapeUISchema;
    return {
      editor: (
        <StepConfigEditorRouter
          key={variableName}
          config={config.lookupBy == null ? {...config, lookupBy: 'id'} : config}
          configShape={configShape}
          dataTestAttrs={{key: variableName}}
          onChangeConfig={onChangeConfig}
          disabled={disabled}
          uiSchema={field}
        />
      ),
    };
  });

  return (
    <div className={css(styles.lookupConfigContainer)}>
      <StepConfigFieldsTemplate numColumns={2} fields={fields} isCompact={true} />
    </div>
  );
}

const styles = StyleSheet.create({
  lookupConfigContainer: {
    // StepConfigFieldsTemplate adds extra horizontal padding when used in a custom component,
    // so we use negative margins to align this editor with the rest of the step config
    margin: '0 -10px',
  },
});
